import FailedLogo from "../assets/failed.gif";
import SuccessLogo from "../assets/success.gif";
import { useNavigate } from "react-router-dom";
import { useGlobalContext } from "../context/GlobalContext/GlobalContext";

export default function StatusScreen({ status }: { status: boolean }) {
  const navigate = useNavigate();
  const { transakOrderData } = useGlobalContext();

  const orderData = transakOrderData && transakOrderData.status;
  const orderAmount = orderData && orderData.fiatAmountInUsd;
  const orderSymbol = orderData && orderData.cryptoCurrency;
  const logo = status ? SuccessLogo : FailedLogo;
  const text = status ? `$${orderAmount} worth ${orderSymbol} added to your AAVE balance` : "Oh! Your order failed!!";
  const cta = status ? "Go to wallet" : "Try Again";
  const onClick = status ? () => navigate("/wallet") : () => navigate("/");

  const Button = () => {
    return (
      <div className="flex flex-col items-center justify-center px-4 py-2 sm:px-10 mt-20">
        <button onClick={onClick} className="bg-black hover:bg-slate-700 text-white font-bold py-2 px-4">
          {cta}
        </button>
      </div>
    );
  };

  return (
    <div className="flow-root">
      <main className="flex flex-col items-center justify-center px-4 py-20 sm:px-10 mt-20">
        <img className="w-40" src={logo} alt="React Logo" />
        <p className="truncate text-sm font-medium text-gray-900  mt-2 mb-0">{text}</p>
        <Button />
      </main>
    </div>
  );
}
